import {
	EnumUtils
} from "../enums/enumUtils";

function enumDisplay(value, type) {
	return EnumUtils.getEnumDisplay(type, value);
}

function handelPay(val) {
	if (val == 1) {
		return '微信支付'
	}
	if (val == 2) {
		return '支付宝支付'
	}
	if (val == 3) {
		return '线上支付'
	}
	if (val == 4) {
		return '套餐权益抵扣'
	}
	if (val == 5) {
		return '优惠卷抵扣'
	}if (val == 6) {
		return '无支付'
	}if (val == 7) {
		return '患者组织赠送'
	}if (val == 8) {
		return '卡密兑换'
	}
}

export {
	enumDisplay,
	handelPay
};